import React from 'react';

import { BodyLargeText, Column, H3, Ul, A } from 'playful-ui';

export const Module1 = () => (
  <React.Fragment>
    <Column style={{ maxWidth: '754px' }} className="left">
      <H3 style={{ alignSelf: 'center', marginTop: '64px' }}>Izrada Mobilne Aplikacije</H3>
      <BodyLargeText>
        Izradi vlastitu mobilnu aplikaciju za upravljanje robota koristeći sučelje s blokovskim programiranjem.
      </BodyLargeText>
      <Ul style={{ marginLeft: '48px' }}>
        <li>Uvod: Izrada mobilnih aplikacija u robotici</li>
        <li><b>Osmišljanje i dizajn</b> mobilne aplikacije</li>
        <li><b>Blokovsko programiranje</b> mobilne aplikacije u MIT App Inventoru</li>
        <li><b>Upravljanje STEMI robota</b> putem vlastite mobilne aplikacije</li>
        <li>Izvještaj</li>
      </Ul>
      <BodyLargeText>
        Rezultat: <b>Doma nosiš mobilnu aplikaciju koju sama/sam isprogramiraš.</b>
      </BodyLargeText>

      <H3 style={{ alignSelf: 'center', marginTop: '32px' }}>3D Modeliranje</H3>
      <BodyLargeText>
        Upoznaj se s 3D printerom, osmisli vlastiti 3D model i provedi svoju ideju u djelo koristeći
        tehnologiju budućnosti - 3D printanje.
      </BodyLargeText>
      <Ul style={{ marginLeft: '48px' }}>
        <li>Uvod: 3D modeliranje u robotici</li>
        <li><b>3D modeliranje</b> u programu Fusion 360</li>
        <li><b>Osmišljanje i dizajn</b> vlastitog modela</li>
        <li>Priprema za <b>3D print</b> u programu Cura</li>
        <li><b>Izrada</b> osmišljenog 3D modela -  3D print</li>
        <li>Izvještaj</li>
      </Ul>
      <BodyLargeText>
        Rezultat: <b>Doma nosiš 3D figuru koju sama/sam osmisliš, dizajniraš te isprintaš. Pohvali
        se roditeljima i frendovima!</b>
      </BodyLargeText>

      <H3 style={{ marginTop: '64px' }}>Detalji</H3>
      <BodyLargeText>
        Modul 1 se sastoji od <b>četiri blok sata</b> raspoređenih u mjesec dana u dogovorenim terminima.
      </BodyLargeText>
      <BodyLargeText><b>Termini:</b></BodyLargeText>
      <Ul style={{ marginLeft: '48px' }}>
        <li><b>ponedjeljkom od 19 do 20:30</b> ili</li>
        <li><b>utorkom od 19 do 20:30</b></li>
      </Ul>
      <BodyLargeText>
        Prilikom prijave putem obrasca ili e-maila, molimo vas da napišete za koji se termin
        prijavljujete. Dodatne termine ćemo organizirati za osobe kojima nijedan od ponuđenih termina ne odgovara.
      </BodyLargeText>
      <BodyLargeText>
        <b>Lokacija održavanja radionica:</b> Lastovska 23, 5.kat, Learn@CROZ.
      </BodyLargeText>
      <BodyLargeText>
        Potrebno je donijeti samo <b>Android uređaj (mobitel ili tablet)</b> i puno dobre volje, svu
        ostalu opremu, kao što su 3D printeri, roboti i računala, osigurava STEMI.
      </BodyLargeText>
      <BodyLargeText>
        <b>Vaše mjesto na radionici osiguravate potvrdom o uplati:</b>
      </BodyLargeText>
      <Ul style={{ marginLeft: '48px' }}>
        <li><b>IBAN</b>: HR8623600001102566394</li>
        <li><b>Opis plaćanja</b>: Ime i prezime - stemi radionice</li>
      </Ul>
    </Column>
  </React.Fragment>
);
